/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { EmotionStrictHttpResponse } from '../../emotion-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmotionsHistoryResponse } from '../../models/emotions-history-response';

export interface ConsumerHistoryGet$Params {
}

export function consumerHistoryGet(http: HttpClient, rootUrl: string, params?: ConsumerHistoryGet$Params, context?: HttpContext): Observable<EmotionStrictHttpResponse<Array<EmotionsHistoryResponse>>> {
  const rb = new RequestBuilder(rootUrl, consumerHistoryGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as EmotionStrictHttpResponse<Array<EmotionsHistoryResponse>>;
    })
  );
}

consumerHistoryGet.PATH = '/Consumer/History';
